<div class="no-data-wrapper">
  <p class="no-data-message">{{ message() }}</p>
</div>
